import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { addDisplayName } from "../Infra/display-name";
import { StepsContainer, StepRow, StepIconContainer, StepTextContainer, StepText, DividerContainer, DividerLineWrapper, DividerLine, } from "./DocumentRetrievalRecordsShared.styles";
import { CheckFilledIcon, ConfirmButton, DescriptionIconEnabled, DomainAddIconDisabled, FooterPlaceholderButton, PageWithFixedHeaderAndFooterContent, PatientConsentParent, TextButton, } from "./PatientConsentManagerShared.styles";
import { useViewModel } from "./useViewModel";
import { PatientConsentVerifiedViewModel } from "./PatientConsentVerifiedViewModel";
import { PatientConsentPDDEGDUBaseAnimatingComponent } from "./PatientConsentPDDEGDUBaseAnimatingComponent";
import { ScreenshotReadinessDetector } from "./ScreenshotReadinessDetector";
import { ContentContainer } from "./HXMobilePage.styles";
export const PatientConsentVerifiedView = observer((props) => {
    const model = useViewModel(PatientConsentVerifiedViewModel, props.container);
    const { t } = useTranslation(["patients"]);
    const steps = [
        {
            id: "identity-verified",
            text: t("Identity verified"),
            isCompleted: true,
            isActive: false,
            icon: _jsx(CheckFilledIcon, {}),
        },
        {
            id: "access-confirmed",
            text: model.findRecordsText,
            isCompleted: false,
            isActive: true,
            icon: _jsx(DescriptionIconEnabled, {}),
        },
        {
            id: "sharing-records",
            text: model.shareRecordsText,
            isCompleted: false,
            isActive: false,
            icon: _jsx(DomainAddIconDisabled, {}),
        },
    ];
    const animate = model.animate;
    return (_jsx(ScreenshotReadinessDetector, { isScreenshotMode: model.isScreenshotMode, children: _jsx(PageWithFixedHeaderAndFooterContent, { isHeaderAndFooterFixed: model.isHeaderAndFooterFixed, children: _jsx(PatientConsentParent, { children: _jsx(ContentContainer, { children: _jsx(PatientConsentPDDEGDUBaseAnimatingComponent, { title: model.title, supportingText: model.supportingText, buttons: model.isWelcomeBack ? (_jsxs(_Fragment, { children: [_jsx(ConfirmButton, { onClick: () => model.continueWhereILeftOff(), children: t("Resume where I left off") }), _jsx(TextButton, { onClick: () => model.goToNextPage(), children: t("Continue from here") })] })) : (_jsxs(_Fragment, { children: [_jsx(ConfirmButton, { onClick: () => model.goToNextPage(), children: t("Continue") }), _jsx(FooterPlaceholderButton, {})] })), animate: animate, children: (isAnimating) => (_jsx(StepsContainer, { isAnimating: isAnimating, animate: animate, children: steps.map((step, index) => (_jsxs(React.Fragment, { children: [_jsxs(StepRow, { children: [_jsx(StepIconContainer, { isActive: step.isActive, isCompleted: step.isCompleted, children: step.icon }), _jsx(StepTextContainer, { isCompleted: step.isCompleted, children: _jsx(StepText, { isActive: step.isActive, children: step.text }) })] }), index < steps.length - 1 && (_jsxs(DividerContainer, { children: [_jsx(DividerLineWrapper, {}), _jsx(DividerLine, {})] }))] }, step.id))) })) }) }) }) }) }));
});
addDisplayName(PatientConsentVerifiedView, "PatientConsentVerifiedView");
